<template>
  <div style="margin-top: 0; margin-left: 0">
    <div
      style="width: 465px; margin-bottom: 20px; margin-top: 25px; position: relative;"
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span v-if="store.langSelect.value == 0">
          Комиссия сети вычитается из указываемой сумму к выводу
        </span>
        <span v-else
          >The network commission is included in the withdrawal amount</span
        >
        <br /><br />
      </div>
    </div>
    <div v-if="!requestSended">
      <div class="myselector" style="width: 507px">
        <el-select
          v-model="selectedaccount"
          icon-сlass="caret-top"
          :placeholder="messages.withdrawalSel[store.langSelect.value]"
        >
          <el-option
            v-for="(item, i) in accounts"
            :key="i"
            :label="item.Account"
            :value="item.Account"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="selectedaccount" style="margin-top: 20px">
        <div
          style="width: 465px; margin-bottom: 0; position: relative;"
          class="lk_content_info_block"
        >
          <div style="display: table-cell; width: 70px">
            <el-icon
              style="
                font-size: 50px;
                position: absolute;
                transform: rotate(180deg);
                left: 20px;
                color: #e82862;
              "
              ><Warning
            /></el-icon>
          </div>
          <div
            style="display: table-cell"
            v-if="selectedCurrency.Ticker === 'AE'"
            v-html="messages.withdrawalAE[store.langSelect.value]"
          ></div>
          <div style="display: table-cell" v-else>
            <div v-html="messages.withdrawalT[store.langSelect.value]"></div>
            <div
              v-html="
                messages.withdrawalFor[store.langSelect.value][
                  selectedCurrency.Ticker
                ]
              "
            ></div>
          </div>
        </div>
        <div style="margin-top: 20px; width:507px">
          <el-select
            v-model="selectedCurrency"
            value-key="Ticker"
            placeholder="Select"
          >
            <el-option
              v-for="(item, i) in currency_info"
              :key="i"
              :label="item.Ticker"
              :value="item"
            >
            </el-option>
          </el-select>
          <span v-if="selectedCurrency" style="margin-left: 20px;font-size: 80%">{{ 
            selectedCurrency.Shares
          }}</span>
          <div v-show="selectedaccount" style="margin-top: 10px">
            <input
              :placeholder="messages.withdrawalSum[store.langSelect.value]"
              v-model="summBtc"
              :class="[
                !summBtcClass
                  ? 'lk_content_form_input'
                  : 'lk_content_form_input_error',
              ]"
            />
            <input
              :placeholder="messages.withdrawalAddr[store.langSelect.value]"
              v-model="addessBtc"
              :class="[
                !addessBtcClass
                  ? 'lk_content_form_input'
                  : 'lk_content_form_input_error',
              ]"
            />
            <Button
              :text="messages.withdrawalB[store.langSelect.value]"
              @click="CheckCode"
            />
          </div>
        </div>
      </div>
      <div style="margin-top: 20px"></div>
      <div style="margin-top: 50px">
        <ServiceHistotyTable>
          <template v-slot:mtthead="">
            <div class="th">Date</div>
            <div class="th">Account</div>
            <div class="th">Currency</div>
            <div class="th">Value</div>
            <div class="th">Address</div>
          </template>
          <template v-slot:mttbody="props">
            <div class="tr" v-if="props.item.Service === 'withdrawal'">
              <div class="td">{{ getStringTime(props.item.Date) }}</div>
              <div class="td">{{ props.item.HistoryInfo.Account }}</div>
              <div class="td">{{ props.item.HistoryInfo.Currency }}</div>
              <div class="td">{{ props.item.HistoryInfo.Value }}</div>
              <div class="td">{{ props.item.HistoryInfo.Address }}</div>
            </div>
          </template>
        </ServiceHistotyTable>
        <MoneyTransactionHistoryTable
          :account="selectedaccount"
          v-if="selectedaccount != ''"
        >
          <template v-slot:mtthead="">
            <div class="th">Date</div>
            <div class="th">Account</div>
            <div class="th">Currency</div>
            <div class="th">Value</div>
          </template>
          <template v-slot:mttbody="props">
            <div
              class="tr"
              v-if="props.src === 'admin' && props.item.crd == 'system'"
            >
              <div class="td">{{ getStringTime(props.item.m) }}</div>
              <div class="td">{{ props.item.dbt }}</div>
              <div class="td">{{ props.item.cur }}</div>
              <div class="td">{{ props.item.val }}</div>
            </div>
          </template>
        </MoneyTransactionHistoryTable>
      </div>
    </div>
    <div v-else>
      <h3>{{ messages.withdrawalSent[store.langSelect.value] }}</h3>
      <ServiceHistotyTable>
        <template v-slot:mtthead="">
          <div class="th">Date</div>
          <div class="th">Account</div>
          <div class="th">Currency</div>
          <div class="th">Value</div>
          <div class="th">Address</div>
        </template>
        <template v-slot:mttbody="props">
          <div class="tr" v-if="props.item.Service === 'withdrawal'">
            <div class="td">{{ getStringTime(props.item.Date) }}</div>
            <div class="td">{{ props.item.HistoryInfo.Account }}</div>
            <div class="td">{{ props.item.HistoryInfo.Currency }}</div>
            <div class="td">{{ props.item.HistoryInfo.Value }}</div>
            <div class="td">{{ props.item.HistoryInfo.Address }}</div>
          </div>
        </template>
      </ServiceHistotyTable>
    </div>
  </div>
  <CheckCode
    :show="ShowCheck"
    :checkedfn="sendRequest"
    @closedialog="CloseCodeDialog"
  ></CheckCode>
</template>

<script>
import { useMyStorage, getAccPositions } from "@/store/global";
import { ref, watch } from "vue";
import MoneyTransactionHistoryTable from "./MoneyTransactionHistoryTable";
import Button from "@/components/Button";
import CheckCode from "@/components/CheckCode";
import ServiceHistotyTable from "./ServiceHistotyTable";
import axios from "axios";
import { Warning } from "@element-plus/icons-vue";

export default {
  name: "WithdrawalComponent",
  components: {
    Button,
    CheckCode,
    MoneyTransactionHistoryTable,
    Warning,
    ServiceHistotyTable,
  },
  setup() {
    const store = useMyStorage();
    const ShowCheck = ref(false);
    const accounts = store.userInfo.value.Info.Accounts;
    const selectedaccount = ref("");
    const currency_info = ref({});
    const selectedCurrency = ref("");
    const requestSended = ref(false);
    const summBtc = ref("");
    let summBtcClass = false;
    const addessBtc = ref("");
    let addessBtcClass = false;
    let positions_info = getAccPositions(selectedaccount.value);
    const getCurrencyInfo = () => {
      currency_info.value = {};
      selectedCurrency.value = "";

      let res = positions_info.value.filter((item) => item.Ticker.length < 5 && (item.Ticker==="USDT" || item.Ticker==="BTC"));
      currency_info.value = res;
      if (currency_info.value !== {}) {
        selectedCurrency.value = currency_info.value[0];
      }
    };
    watch(
      () => selectedaccount.value,
      (val) => {
        positions_info = getAccPositions(val);
        getCurrencyInfo();
      }
    );
    const CloseCodeDialog = () => {
      // console.log("emit")
      ShowCheck.value = false;
    };
    const CheckCode = () => {
      //   console.log(ShowCheck.value)
      ShowCheck.value = true;
    };

    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };
    const getStringTime = (dt) => {
      const ts= new Date(dt)
      // console.log(val)
       console.log("++++++++++"+ts+"----------")

        return (
          ts.getUTCFullYear() +
          "-" +
          pad(ts.getUTCMonth() + 1) +
          "-" +
          pad(ts.getUTCDate()) +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
    };
    const sendRequest = () => {
      //  let token = store.token.value;
      const data = {
        sum: summBtc.value.trim() + " " + selectedCurrency.value.Ticker,
        account: selectedaccount.value.trim(),
        addr: addessBtc.value.trim(),
      };
      // console.log(token);
      //     axios.defaults.headers.common["Authorization"] = token;
      axios.post(store.ServerUrl + "/users/btcrequest", data);
      requestSended.value = true;
      let info =
        "{'service':'Withdrawal', 'Account':'" +
        selectedaccount.value.trim() +
        "', 'Value':'" +
        summBtc.value.trim() +
        "', 'Currency':'" +
        selectedCurrency.value.Ticker +
        "', 'Address':'" +
        addessBtc.value.trim() +
        "'}";
      let shis = {
        service: "withdrawal",
        accounts: selectedaccount.value,
        email: store.userInfo.value.Roles.email,
        status: "pending",
        historyinfo: info,
      };
      axios
        .post(store.ServerUrl + "/users/savesevicehistory", shis)
        .finally(() => {
          store.LoadServiceHistory(selectedaccount.value);
        });
    };
    /*selectedaccount.value = accounts[0];
    positions_info = getAccPositions(selectedaccount.value);
    getCurrencyInfo();*/
    return {
      store,
      sendRequest,
      requestSended,
      positions_info,
      accounts,
      currency_info,
      selectedaccount,
      selectedCurrency,
      addessBtc,
      summBtc,
      summBtcClass,
      addessBtcClass,
      ShowCheck,
      CheckCode,
      CloseCodeDialog,
      getStringTime,
      messages: {
        withdrawalT: [
          "Заявка, поданная до 14:00 UTC, обрабатывается до конца дня. По заявке поданной после 14:00 UTC вывод средств производится на следующий день. ",
          "Applications submitted before 14:00 UTC are processed by the end of the day. For applications submitted after 14:00 UTC, the withdrawal of funds is made the next day.",
        ],
        withdrawalH: ["Заявка на вывод средств", "Withdrawal request"],
        withdrawalSel: ["Выберите счет", "Select account"],
        withdrawalSum: ["Сумма к выводу", "Amount to be withdrawn"],
        withdrawalAddr: ["Адрес", "Address"],
        withdrawalB: ["Отправить", "Send"],
        withdrawalSent: [
          "Ваш запрос отправлен.",
          "Your request has been sent.",
        ],
        withdrawalFor: [
          {
            USDT: "Вывод USDT только TRC20 сети Tron <br>Минимальная сумма вывода 10 USDT<br> Комиссия сети 3 USDT",
            BTC: "Минимальная сумма вывода 0.0001 BTC <br> Комиссия сети 0.0001 - 0.00077",
            AE: "",
          },
          {
            USDT: "USDT Withdrawal Only TRC20 Tron Network<br>Minimum withdrawal amount 10 USDT<br>Network fee 3 USDT",
            BTC: "Minimum withdrawal amount 0.0001 BTC<br>Network commission 0.0001 - 0.00077",
            AE: "",
          },
        ],
        withdrawalAE: [
          "Вывод токена АЕ временно не производится",
          "The withdrawal of the AE token is temporarily not available",
        ],
      },
    };
  },
};
</script>

<style scoped></style>
